import React from "react";
import { NavLink } from "react-router-dom";
import { IconHelp, IconMail, IconOverview, IconProcurement, IconReport, IconSettings, IconTables } from "./ui/icons";
import { useTheme } from "../context/ThemeContext";

// Routes and labels stay the same; they are only split into working screens (top) and utility ones (bottom).
const MAIN_TABS = [
  { to: "/", label: "Kontrolna tabla", end: true, icon: IconOverview },
  { to: "/tables", label: "Zauzetost stolova", icon: IconTables },
  { to: "/report", label: "Promet artikala", icon: IconReport },
  { to: "/consumption", label: "Nabavka", icon: IconProcurement },
];
const UTILITY_TABS = [
  { to: "/settings", label: "Podešavanja", icon: IconSettings },
  { to: "/help", label: "Pomoć", icon: IconHelp },
  { to: "/kontakt", label: "Kontakt", icon: IconMail },
];

const itemClass = ({ isActive }) =>
  `group relative flex h-9 items-center gap-2.5 rounded-md px-2.5 text-sm font-medium transition-colors ${
    isActive
      ? "bg-slate-100 text-slate-900 dark:bg-slate-800 dark:text-slate-50"
      : "text-slate-600 hover:bg-slate-100/70 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-slate-800/60 dark:hover:text-slate-100"
  }`;

function NavItem({ tab, onNavigate }) {
  return (
    <NavLink to={tab.to} end={tab.end} className={itemClass} onClick={onNavigate}>
      {({ isActive }) => (
        <>
          <span
            aria-hidden="true"
            className={`absolute bottom-1.5 left-0 top-1.5 w-0.5 rounded-full bg-primary transition-opacity dark:bg-primary-light ${
              isActive ? "opacity-100" : "opacity-0"
            }`}
          />
          <tab.icon
            aria-hidden="true"
            className={`shrink-0 text-lg transition-colors ${
              isActive
                ? "text-primary dark:text-primary-light"
                : "text-slate-400 group-hover:text-slate-600 dark:text-slate-500 dark:group-hover:text-slate-300"
            }`}
          />
          {tab.label}
        </>
      )}
    </NavLink>
  );
}

export default function Sidebar({ className = "", onNavigate }) {
  const { darkMode } = useTheme();
  return (
    <aside
      className={`flex h-full w-56 shrink-0 flex-col border-r border-slate-200 bg-surface dark:border-slate-800 dark:bg-slate-900 ${className}`}
    >
      <div className="flex h-14 shrink-0 items-center border-b border-slate-200 px-4 dark:border-slate-800">
        {/* Fixed logo of the company that built the app; the customer's own logo is used only in exports and prints. */}
        <img src={darkMode ? "/logo-light.png" : "/logo-dark.png"} alt="Logik" className="h-6 w-auto" />
      </div>

      <nav aria-label="Glavna navigacija" className="flex flex-1 flex-col gap-0.5 px-2 py-3">
        {MAIN_TABS.map((tab) => (
          <NavItem key={tab.to} tab={tab} onNavigate={onNavigate} />
        ))}
        <div className="mt-auto flex flex-col gap-0.5 border-t border-slate-200 pt-3 dark:border-slate-800">
          {UTILITY_TABS.map((tab) => (
            <NavItem key={tab.to} tab={tab} onNavigate={onNavigate} />
          ))}
        </div>
      </nav>
    </aside>
  );
}
